function initShoeCare(scope = document) {
  scope.querySelectorAll('[data-sc-product]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const photo = root.querySelector('.sc-gallery-image');
    const thumbs = [...root.querySelectorAll('[data-sc-image]')];
    const select = root.querySelector('[data-sc-variant]');
    const add = root.querySelector('.sc-add');
    const sticky = root.querySelector('.sc-sticky-buy');
    const stickyAdd = root.querySelector('.sc-sticky-add');
    const groups = [...root.querySelectorAll('.sc-option-group')];
    const variants = [...select.options].map(option => ({option, values: JSON.parse(option.dataset.options)}));
    function show(btn) {
      if (!btn) return;
      photo.src = btn.dataset.scImage;
      photo.alt = btn.dataset.scAlt;
      thumbs.forEach(x => x.setAttribute('aria-pressed', String(x === btn)));
    }
    thumbs.forEach(btn => btn.addEventListener('click', () => show(btn)));
    let swipeStart;
    photo.addEventListener('touchstart', event => { swipeStart = event.touches[0].clientX; }, {passive:true});
    photo.addEventListener('touchend', event => {
      if (swipeStart === undefined) return;
      const delta = event.changedTouches[0].clientX - swipeStart;
      swipeStart = undefined;
      if (Math.abs(delta) < 45) return;
      const index = thumbs.findIndex(btn => btn.getAttribute('aria-pressed') === 'true');
      show(thumbs[(index + (delta < 0 ? 1 : -1) + thumbs.length) % thumbs.length]);
    }, {passive:true});
    function update(changeImage = true, updateUrl = true) {
      const option = select.selectedOptions[0];
      const values = JSON.parse(option.dataset.options);
      root.querySelector('[data-sc-price]').textContent = option.dataset.price;
      root.querySelector('[data-sc-sticky-price]').textContent = option.dataset.price;
      root.querySelector('[data-sc-selection]').textContent = values.join(' / ');
      [add, stickyAdd].forEach(button => {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? add.dataset.unavailableLabel : add.dataset.addLabel;
      });
      groups.forEach((group, index) => {
        group.querySelectorAll('input').forEach(input => { input.checked = input.value === values[index]; });
      });
      root.querySelectorAll('[data-pack-price]').forEach(label => {
        const match = variants.find(v => v.values[0] === label.dataset.packPrice && v.values.slice(1).every((value, i) => value === values[i + 1]));
        label.textContent = match ? match.option.dataset.price : '';
      });
      if (changeImage) {
        const index = option.dataset.color === 'Gray' ? 2 : option.dataset.color === 'Yellow' ? 1 : 0;
        show(thumbs[index]);
      }
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      }
    }
    select.addEventListener('change', () => update());
    groups.forEach(group => group.addEventListener('change', () => {
      const values = groups.map(g => g.querySelector('input:checked')?.value);
      const match = variants.find(v => v.values.every((value, i) => value === values[i]));
      if (match) { select.value = match.option.value; update(); }
      else update(false, false);
    }));
    update(true, false);
    root.querySelector('.sc-option-groups').hidden = false;
    select.hidden = true;
    root.querySelector('.sc-native-label').hidden = true;
    function syncSticky() {
      const rect = add.getBoundingClientRect();
      sticky.hidden = rect.bottom >= 0;
    }
    const observer = new IntersectionObserver(syncSticky, {threshold: 0});
    observer.observe(add);
    window.addEventListener('resize', syncSticky, {passive: true});
    syncSticky();
  });
}
initShoeCare();
document.addEventListener('shopify:section:load', event => initShoeCare(event.target));

